module.exports = __webpack_public_path__ + "img/family-occupancy.80578c84.webp";